import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface TorsenDifferencialProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function TorsenDifferencial(props: TorsenDifferencialProps) {
  return (
    <svg
      width="56"
      height="42"
      viewBox="0 0 56 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 230, left: 409}}
      onClick={props.onClick}
    >
      <path
        d="M55 33C55 34.6 53.6667 35 53 35H41C41 36.6 39.6667 37 39 37H37C37 38.6 35.6667 39 35 39H5C5 40.6 3.66667 41 3 41H1V1H3C3.66667 1 5 1.4 5 3H35C35.6667 3 37 3.4 37 5H39C39.6667 5 41 5.4 41 7H53C53.6667 7 55 7.4 55 9V33Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M5 39C5 39 31 39 34 39C37 39 37.0001 37 37.0001 37V21V5C37.0001 5 37 3 34 3C31 3 5 3 5 3"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M41 35C41 35 49 35 52 35C55 35 55.0001 33 55.0001 33V21V9C55.0001 9 55 7 52 7C49 7 41 7 41 7"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M3 5H1V1H3C3 1 5 1 5 3C5 5 3 5 3 5Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M39 9H37V5H39C39 5 41 5 41 7C41 9 39 9 39 9Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M39 23H37V19H39C39 19 41 19 41 21C41 23 39 23 39 23Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M39 37H37V33H39C39 33 41 33 41 35C41 37 39 37 39 37Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M3 17H1V13H3C3 13 5 13 5 15C5 17 3 17 3 17Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M3 29H1V25H3C3 25 5 25 5 27C5 29 3 29 3 29Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M3 41H1V37H3C3 37 5 37 5 39C5 41 3 41 3 41Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M29 9H37V5H29C29 5 27 5 27 7C27 9 29 9 29 9Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M29 23H37V19H29C29 19 27 19 27 21C27 23 29 23 29 23Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M29 37H37V33H29C29 33 27 33 27 35C27 37 29 37 29 37Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </svg>
  );
}
